import { isDev } from 'config'
import { getAnalytics } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'
import { getMessaging } from 'firebase/messaging'
import { getRemoteConfig } from 'firebase/remote-config'

const app = initializeApp({
  apiKey: 'AIzaSyCa6wL3iBz_VUZIjc_XkEODw2z0AAAW-fM',
  projectId: 'yay-space',
  messagingSenderId: '287723651699',
  appId: '1:287723651699:web:dd73f4f4bc9258bb8c2006',
  measurementId: 'G-FCYBYY66VR',
})
const analytics = getAnalytics(app)

const firebaseRemoteConfig = getRemoteConfig(app)
firebaseRemoteConfig.settings.fetchTimeoutMillis = 10000
if (isDev) {
  firebaseRemoteConfig.settings.minimumFetchIntervalMillis = 3000
}

const messaging = () => getMessaging(app)

export { messaging, firebaseRemoteConfig, analytics }
